<template>
  <router-view/>
</template>
<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'
import { SecurityItemsKeys } from '@/enum/SecurityItems';

  
@Component({
  name: 'Pilot', 
})
export default class Pilot extends Vue {      
  beforeRouteEnter(to:any,from:any,next:any) {          
    next((vm:Pilot) => {              
      next((vm.$store.myGetters.userSecurity[SecurityItemsKeys.HOME_PILOT].enable || 
            vm.$store.myGetters.userSecurity[SecurityItemsKeys.HOME_VIEW_DATA].enable)?'':'/login')
    })  
  }

  mounted(){
    this.$vuetify.theme.primary = '#4066aa'
    this.$vuetify.theme.secondary = '#ec7404'    
  }
}
</script> 